import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {YN} from '../../common/shared/api/YN.type';

/**
 * TVPoint 약관 동의 여부 확인
 *
 * Origin: pageNicolasApi.getTvPointTermsCheck
 * API: POST /api/v1/store/terms/check/page_private_tvpoint_offer
 */
export async function getStoreTvPointTermsCheck(
  options?: FetcherOptions
): Promise<ApiResultVo & {request_agree: YN}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/terms/check/page_private_tvpoint_offer',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
    options
  );

  return response.data;
}
